import React, { useEffect, useRef, useState } from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { PlayCircleOutlined, PauseCircleOutlined, RedoOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

type Phase = 'inhale' | 'hold1' | 'exhale' | 'hold2';

const PHASE_DURATION = 4000; // 4 seconds per phase (box breathing)

const PHASE_LABEL: Record<Phase, string> = {
  inhale: 'Hít vào...',
  hold1: 'Giữ hơi...',
  exhale: 'Thở ra...',
  hold2: 'Giữ hơi...',
};

const PHASE_ORDER: Phase[] = ['inhale', 'hold1', 'exhale', 'hold2'];

const BreathingExercise: React.FC = () => {
  const [running, setRunning] = useState(false);
  const [phase, setPhase] = useState<Phase>('inhale');
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (running) {
      intervalRef.current = window.setInterval(() => {
        setPhase((prev) => {
          const currentPos = PHASE_ORDER.indexOf(prev);
          return PHASE_ORDER[(currentPos + 1) % PHASE_ORDER.length];
        });
      }, PHASE_DURATION);
    } else if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }
    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, [running]);

  const handleToggle = () => {
    setRunning((prev) => !prev);
  };

  const handleReset = () => {
    setRunning(false);
    setPhase('inhale');
  };

  const circleClass = `breathing-circle ${running ? `phase-${phase}` : 'phase-idle'}`;

  return (
    <Card className="breathing-card" title="Bài tập hít thở (Box Breathing)">
      <div className="breathing-container">
        <div className={circleClass}>
          <Title level={4} className="breathing-phase-label">
            {running ? PHASE_LABEL[phase] : 'Sẵn sàng?'}
          </Title>
        </div>
        <Text type="secondary" className="breathing-hint">
          4 giây hít vào &middot; 4 giây giữ &middot; 4 giây thở ra &middot; 4 giây giữ
        </Text>
        <Space className="breathing-controls">
          <Button
            type="primary"
            icon={running ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
            onClick={handleToggle}
          >
            {running ? 'Tạm dừng' : 'Bắt đầu'}
          </Button>
          <Button icon={<RedoOutlined />} onClick={handleReset}>
            Đặt lại
          </Button>
        </Space>
      </div>
    </Card>
  );
};

export default BreathingExercise;
